module.exports = __webpack_public_path__ + "media/Man_Chat_1.8dbed4d0.mp3";